import { urls } from 'constants/urls';
import { useQuery } from '@tanstack/react-query';
import { bffApiService } from 'config/service';
import { TFeatureData } from './types';

const getFeatures = () => bffApiService.get(urls.featureAccess);

export const useFeatureAccess = () =>
  useQuery<TFeatureData[], Error>({
    queryKey: ['feature-access'],
    queryFn: () => getFeatures().then((res) => res.data),
    staleTime: Infinity,
  });
